module.exports = {
  src: __webpack_public_path__ + "assets/images/watch-later.7ff7f2af481e711b.svg",
  width: 17,
  height: 17,
  toString: function() { return __webpack_public_path__ + "assets/images/watch-later.7ff7f2af481e711b.svg"; }
};